import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=1bf4f7ef&scoped=true&"
import script from "./Project.vue?vue&type=script&setup=true&lang=js&"
export * from "./Project.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=1bf4f7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4f7ef",
  null
  
)

export default component.exports